module.exports = __webpack_public_path__ + "img/well_organized.ca6a6812.svg";